import { useEffect, useState, useContext } from "react";
import { getInlineLoader } from "../Helpers";
import {
  FiLinkedin,
  FiTwitter,
  FiArrowUpRight,
  FiLayers,
  FiTerminal,
  FiGlobe,
  FiCheckCircle,
} from "react-icons/fi";
import { IoMdMail } from "react-icons/io";
import peter from "../assets/peter.jpeg";
import { AppContext } from "../App";
import Footer from "./Footer";
import { FaQuoteRight } from "react-icons/fa6";

export default function CeoWord() {
  const [ready, setReady] = useState(false);
  const appContext = useContext(AppContext);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container min-vh-100 d-flex align-items-center justify-content-center">
        {getInlineLoader()}
      </div>
    );
  }

  const ceoData = {
    name: "Peter Ndomano",
    role: "Managing Director & CEO",
    specialty: "Full-Stack Architect",
    image: peter,
    headline: "Architecting Scalable, High-Impact Digital Solutions",
    quote:
      "Technology is most powerful when it seamlessly aligns with human enterprise. Our core mission is not just to write code, but to engineer resilient, forward-thinking infrastructure that empowers businesses to scale globally with absolute security and agility.",
    extendedVision:
      "Every project we undertake is driven by a deep commitment to technical excellence and user-first design. We collaborate directly with our partners to turn complex technological challenges into intuitive, high-performance competitive advantages.",
  };

  return (
    <>
      <section className="wer-ceo-section position-relative py-5 overflow-hidden">
        <style>{`
          .wer-ceo-section {
            font-family: 'Inter', system-ui, -apple-system, sans-serif;
            background: linear-gradient(135deg, #070b12 0%, #0f172a 45%, #1e293b 80%, #0f172a 100%);
            color: #f8fafc;
            min-height: 85vh;
            display: flex;
            align-items: center;
          }

          /* Ambient Gradient Overlays */
          .wer-glow-overlay-1 {
            position: absolute;
            top: -15%;
            left: -10%;
            width: 600px;
            height: 600px;
            background: radial-gradient(circle, rgba(14, 165, 233, 0.18) 0%, rgba(15, 23, 42, 0) 70%);
            border-radius: 50%;
            pointer-events: none;
          }

          .wer-glow-overlay-2 {
            position: absolute;
            bottom: -20%;
            right: -5%;
            width: 650px;
            height: 650px;
            background: radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, rgba(15, 23, 42, 0) 70%);
            border-radius: 50%;
            pointer-events: none;
          }

          /* Glassmorphic Card Container */
          .wer-ceo-card {
            background: rgba(15, 23, 42, 0.65);
            backdrop-filter: blur(16px);
            -webkit-backdrop-filter: blur(16px);
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: 32px;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
            overflow: hidden;
            position: relative;
            z-index: 1;
          }

          /* Image Frame Design */
          .wer-ceo-img-wrapper {
            position: relative;
            width: 100%;
            max-width: 380px;
            margin: 0 auto;
          }

          .wer-ceo-img-frame {
            position: relative;
            border-radius: 28px;
            overflow: hidden;
            padding: 8px;
            background: linear-gradient(135deg, rgba(56, 189, 248, 0.4) 0%, rgba(99, 102, 241, 0.2) 100%);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
          }

          .wer-ceo-img {
            width: 100%;
            height: 420px;
            object-fit: cover;
            border-radius: 22px;
            display: block;
            filter: brightness(1.02) contrast(1.03);
            transition: transform 0.5s ease;
          }

          .wer-ceo-card:hover .wer-ceo-img {
            transform: scale(1.02);
          }

          /* Badge & Typography */
          .wer-ceo-badge {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 6px 16px;
            border-radius: 9999px;
            background: rgba(14, 165, 233, 0.12);
            border: 1px solid rgba(56, 189, 248, 0.25);
            color: #38bdf8;
            font-size: 0.825rem;
            font-weight: 700;
            letter-spacing: 1px;
            text-transform: uppercase;
          }

          .wer-text-gradient {
            background: linear-gradient(135deg, #ffffff 30%, #93c5fd 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          /* Quote Box */
          .wer-quote-container {
            position: relative;
            padding-left: 24px;
            border-left: 3px solid var(--secondaryColor);
          }

          .wer-quote-icon {
            font-size: 2.5rem;
            color: rgba(56, 189, 248, 0.3);
            position: absolute;
            top: -10px;
            left: -10px;
            z-index: 0;
          }

          /* Interactive Social Buttons */
          .wer-social-icon-btn {
            width: 44px;
            height: 44px;
            border-radius: 12px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.05);
            color: #94a3b8;
            border: 1px solid rgba(255, 255, 255, 0.08);
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            text-decoration: none;
          }

          .wer-social-icon-btn:hover {
            background: #0ea5e9;
            color: #ffffff;
            border-color: #38bdf8;
            transform: translateY(-3px);
            box-shadow: 0 10px 20px -5px rgba(14, 165, 233, 0.4);
          }

          /* Metrics Section Inside Card */
          .wer-metric-pill {
            background: rgba(255, 255, 255, 0.03);
            border: 1px solid rgba(255, 255, 255, 0.06);
            border-radius: 16px;
            padding: 16px 20px;
          }

          @media (max-width: 991.98px) {
            .wer-ceo-img {
              height: 360px;
            }
            .wer-ceo-card {
              border-radius: 24px;
            }
          }
        `}</style>

        {/* Dark Blue Ambient Overlays */}
        <div className="wer-glow-overlay-1"></div>
        <div className="wer-glow-overlay-2"></div>

        <div className="container py-4 position-relative">
          <div className="wer-ceo-card p-4 p-md-5">
            <div className="row g-5 align-items-center">
              {/* Left Column: Image & Leadership Details */}
              <div className="col-lg-5 text-center text-lg-start">
                <div className="wer-ceo-img-wrapper">
                  <div className="wer-ceo-img-frame">
                    <img
                      src={ceoData.image}
                      alt={ceoData.name}
                      className="wer-ceo-img"
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <h3 className="fw-bold mb-1 fs-3 text-white">
                    {ceoData.name}
                  </h3>
                  <p className="text-info fw-semibold mb-2">
                    {ceoData.role}
                  </p>
                </div>
              </div>

              {/* Right Column: CEO Message & Strategic Pillars */}
              <div className="col-lg-7">
                <h1 className="display-6 fw-bold wer-text-gradient mb-4">
                  {ceoData.headline}
                </h1>

                <div className="wer-quote-container mb-4">
                  <p className="fs-5 lh-base text-slate-200 fw-normal mb-0">
                    "{ceoData.quote}"
                  </p>
                </div>

                {/* Key Strategic Pillars / Metrics */}
                <div className="row g-3 pt-2 d-none">
                  <div className="col-sm-4">
                    <div className="wer-metric-pill">
                      <div className="d-flex align-items-center gap-2 mb-1 text-info">
                        <FiCheckCircle size={18} />
                        <span className="fw-bold fs-5">100%</span>
                      </div>
                      <span className="text-muted small d-block">
                        Code Quality & Security
                      </span>
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="wer-metric-pill">
                      <div className="d-flex align-items-center gap-2 mb-1 text-info">
                        <FiGlobe size={18} />
                        <span className="fw-bold fs-5">Global</span>
                      </div>
                      <span className="text-muted small d-block">
                        Scalable Architecture
                      </span>
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="wer-metric-pill">
                      <div className="d-flex align-items-center gap-2 mb-1 text-info">
                        <FiLayers size={18} />
                        <span className="fw-bold fs-5">Modern</span>
                      </div>
                      <span className="text-muted small d-block">
                        Full-Stack Workflows
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {appContext.navItem === "team" ? <Footer /> : ""}
    </>
  );
}